export default {
  sweepstakes: "Sweepstakes",
  content_swap: "Content Swaps",
  product_shipment_insert: "Box-Insert Swaps",
  dedicated_email_buy: "Dedicated Email Buys",
  dedicated_email_sell: "Dedicated Email Sells",
  prizing_partner: "Prizing Partner",
  custom: "Custom",
};
